import React, { useMemo } from "react";

import { compareKeys } from 'mythil/object';
import { useSelector } from 'react-redux'
import { getSubviewTree } from '~/stateGetter';

import ItemViewDialog from "~/ui/ItemViewDialog/ItemViewDialog";

export default function ModelDialogTree() {
    const tree = useSelector((state) => getSubviewTree(state), compareKeys);
    const dialogs = useMemo(() => Object.entries(tree)
        .sort()
        .map(([modelId, showFullscreen]) => {
            return <ItemViewDialog modelId={modelId} key={modelId} size={showFullscreen ? "large-auto" : undefined} />
        }),
        [tree]
    );

    return <>{ dialogs }</>
}

